import './assets/main.scss'

import { createApp } from 'vue'
import pinia from '@/stores'

import App from './App.vue'
import router from './router'

import Vant from 'vant'
import 'vant/lib/index.css' // 引入样式

import toast from './plugins/showToast'

const app = createApp(App)

app.use(pinia)
app.use(Vant)
app.use(toast)
app.use(router)

app.mount('#app')
